import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
        <div className="relative overflow-hidden rounded-3xl bg-accent-500 px-6 md:px-12 py-14 md:py-20 text-center">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20background%20with%20scattered%20minimal%20fashion%20product%20silhouettes%20of%20shoes%20hoodies%20and%20caps%20in%20subtle%20sage%20green%20terracotta%20and%20warm%20sand%20tones%2C%20calm%20modern%20editorial%20aesthetic%2C%20gentle%20layered%20shapes%2C%20high%20detail&width=1200&height=600&seq=usfans-cta-bg-v2&orientation=landscape&nocache=true"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
              {t("finalCta.title")}
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-100 max-w-xl mx-auto">
              {t("finalCta.body")}
            </p>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-background-50 px-8 py-3.5 text-base font-bold text-accent-900 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("finalCta.button")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-base"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}